import { connect } from 'react-redux';

import EventbriteLoginOptions from './EventbriteLoginOptions';

import {
    clearAuthNotification as clearAuthNotificationAction,
    viewPassword as viewPasswordAction,
    resetForm as resetFormAction,
} from '../../actions/auth';

import { logInUser as logInUserAction } from '../../actions/login';

import { sendSoftAccountEmail as sendSoftAccountEmailAction } from '../../actions/softAccount';

import { lookupUser as lookupUserAction } from '../../actions/lookup';

const _mapStateToProps = ({ authentication, frontend }) => ({
    email: authentication.email,
    socialSSOSettings: authentication.socialSSOSettings,
    showCaptcha: authentication.displayCaptcha,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    disableRecaptcha3: authentication.disableRecaptcha3,
    isSoftAccount: frontend.showModal,
});

const _mapDispatchToProps = {
    onLogInUser: logInUserAction,
    onLookupUser: lookupUserAction,
    clearAuthNotification: clearAuthNotificationAction,
    handleSoftAccount: sendSoftAccountEmailAction,
    handleClickViewPassword: viewPasswordAction,
    resetForm: resetFormAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(EventbriteLoginOptions);
